import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { BANKS } from "@/data/markBanks";

let cache = null;
let pending = null;
const subs = new Set();

export const setTerms = (saved) => { cache = saved ? { ...BANKS, ...saved } : BANKS; subs.forEach((f) => f(cache)); };
const load = () => {
  if (!pending) pending = api.get("/game-terms").then(({ data }) => setTerms(data.banks)).catch(() => setTerms(null));
  return pending;
};

// Game term banks: Jason's saved edits from Admin, falling back to the built-in list.
export const useTerms = () => {
  const [banks, setBanks] = useState(cache || BANKS);
  useEffect(() => { subs.add(setBanks); if (!cache) load(); return () => subs.delete(setBanks); }, []);
  return banks;
};
